import './_forms.scss';

$(() => {
    function toggleActive($target) {
        const $label = $target.closest('.nf-field').find('.nf-field-label');
        if (!$target || !$target.val().length) {
            $label.addClass('active');
        } else {
            $label.removeClass('active');
        }
    }
    function initActiveState() {
        const $nfEl = $('.nf-element');
        $nfEl.each((_, ele) => {
            const $target = $(ele);
            toggleActive($target);
        });
        $nfEl.on('input focus blur', (e) => {
            const $target = $(e.target);
            toggleActive($target);
        });
    }

    const checkNinjaFormReady = window.setInterval(() => {
        if ($('.nf-field').length) {
            initActiveState();
            window.clearInterval(checkNinjaFormReady);
        }
    }, 200);
});
